<script>
    import {onMount, createEventDispatcher} from 'svelte';
    import {validateAtInput} from '../Form/utils.js';
    import {slide} from 'svelte/transition';
    import Tag from './Tag.svelte';
    import {debounced, get} from '../../utils.js';
    import {sgettext} from '../../i18n';
    import Spinner from '../Spinner.svelte';

    export let id = 'tagSelect';
    export let data = [];
    export let values = [];
    export let optionsApiUrl = '';
    export let filterKey = '';
    export let allowNewOption = false;
    export let placeholder = sgettext('$$CLICK_ADD_TAG$$');
    export let maxSelection = null;
    export let help = '';
    export let isValid = true;
    export let errors = '';
    export let extraStyle = '';

    const dispatch = createEventDispatcher();

    let showTextInput = false;
    let textInput = null;
    let filterText = '';
    let loading = false;
    let options = data ? data : [];


    function onMouseEnter(event) {
        let target = jQuery(event.target);
        // only trigger on the containing divs (wrapper, selection)
        // or the actual edit/cancel icon  (fa5-edit, fa5-times-circle)
        // (basically everything other than the individual spans containing the actual tags themselves)
        if (target.hasClass('wrapper') || target.hasClass('selection') || target.hasClass('fa5-edit') || target.hasClass('fa5-times-circle')) {
            showTextInput = !showTextInput;

            if (showTextInput) {
                setTimeout(() => {
                        if (textInput) {
                            textInput.focus();
                        }
                    },
                    500);
            }
        }

    }

    function handleValidation() {
        if (maxSelection !== null && values.length + 1 > maxSelection || filterText == "apm") {
            isValid = false;
            errors = ''
            errors += (maxSelection !== null && values.length + 1 > maxSelection ) ? `${sgettext('$$SELECT_1$$')} ${maxSelection} ${sgettext('$$ITEMS_1$$')}.    ` : ''
            errors += filterText == 'apm' ? `${sgettext('$$APM_CANNOT_ADDED_TAG$$')}.   `  : ''
        } else {
            isValid = true;
            errors = '';
        }
    }


    function onMouseLeave(event) {

    }

    function removeTag(event, value) {
        if (typeof value === 'string') {
            values = values.filter(v => v !== value);
        } else {
            if (value.hasOwnProperty('id')) {
                values = values.filter(v => v.id !== value.id);
            }
        }
        dispatch('changed', {
            key: id,
            values
        });
    }

    async function addSelectedTag(event, value) {
        handleValidation();

        if (isValid) {
            values = [...values, value];
            let values_list = values.map(v => v);

            if (typeof value === 'object') {
                values_list = values.map(v => v.name);
            }

            options = options.filter(op => typeof op === 'object' ? !values_list.includes(op.name) :
                        !values.includes(op));

            dispatch('changed', {
                key: id,
                values
            });
        }

    }

    function onKeyUp(event) {
        if (filterText) {
            if (event.key === 'Enter' && (allowNewOption || options.find(opt => opt.name === filterText))) {
                addSelectedTag(event, filterText);
                filterText = '';
            } else {
                getAvailableOptions();
            }
        } else {
            options = [];
        }
    }


    function normalizeOptions(response) {
        const rawOptions = Array.isArray(response) ? response : response.results;
        let filteredOptions = rawOptions;
        if (values.length) {
            filteredOptions = rawOptions.filter(op => typeof op === 'object' ?
                    !values.map(v => v.id).includes(op.id) : !values.includes(op))
        }
        if (filteredOptions.length && typeof filteredOptions[0] === 'string') {
            options = filteredOptions.map(o => ({id: o, name: o}))
        } else {
            options = [...filteredOptions];
        }
    }

    async function getAvailableOptions() {
        if (filterText) {
            loading = true;
            try {
                const resp = await get(`${optionsApiUrl}?${filterKey}=${filterText}`);
                const json = await resp.json();
                normalizeOptions(json);
            } catch (err) {
                console.log(err);
            }

            loading = false;
        }
    }

    function clearOptions() {
        options = [];
        filterText = '';
    }

    onMount(() => {
        normalizeOptions(options);
    });
</script>

<style>
    .wrapper {
        width: 100%;
        padding: 5px;
        border: 1px solid #ced4da;
    }

    .wrapper:hover, .fa5-edit:hover {
        cursor: pointer;
    }

    .tag-input {
        margin-top: 5px;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        border: 1px solid #0099cc;
        padding: 0 10px;
    }

    .tag-input input {
        padding: 3px 5px;
        border: none;
        padding: 3px;
        color: #454545;
    }

    .tag-input input[type="text"]:focus {
        outline: none;
    }

    .errors {
        color: #dc3545;
        font-size: 13px;
    }

    .selection span {
        color: #ced4da;
        padding: 3px;
    }

</style>

<div
        {id}
        class="wrapper"
        title={sgettext("$$CLICK_ADD$$")}
        on:mouseup|stopPropagation={onMouseEnter}
        on:mouseleave={onMouseLeave}
>
    <i class="fas fa5-edit fa5-sm float-right"></i>
    <div class="selection">
        {#if values.length === 0}
            <span>{placeholder}</span>
        {/if}
        {#each values as v}
            {#if v == "apm"}
                <Tag value={v} showIcon={false} />
            {:else}
                <Tag value={v} onClick={removeTag}/>
            {/if}
        {/each}
    </div>

    {#if showTextInput}
        <div class="tag-input" style="{extraStyle}">
            <input
                    type="text"
                    transition:slide|local="{{delay: 150, duration: 500}}"
                    bind:this={textInput}
                    on:keyup={onKeyUp}
                    bind:value={filterText}
            />
            <span class="icon">
            {#if loading}
                <Spinner size="small"/>
            {:else}
                {#if options.length}
                    <span
                            on:click={clearOptions}
                            class="clear-results"><i class="fas fa5-times-circle"></i>
                </span>
                {/if}
            {/if}
        </span>
        </div>
    {/if}
    {#if options.length && showTextInput}
        <div
                class="available-tags"
                transition:slide|local="{{duration: 500}}"
        >
            {#each options as o}
                <Tag value={o} showIcon={false} onClick={addSelectedTag}/>
            {/each}
        </div>
    {/if}
    {#if help}
        <small class="form-text text-muted">{help}</small>
    {/if}

    {#if !isValid}
        <div class="errors">{errors}</div>
    {/if}

</div>